'use client'

import Script from 'next/script'

export function GoogleCallTracking() {
  return (
    <Script
      id="google-ads-call-tracking"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function() {
            // Wait for gtag to be available
            function initCallTracking() {
              if (typeof gtag === 'undefined') {
                setTimeout(initCallTracking, 100);
                return;
              }

              // Google Ads DNI configuration
              // This is the exact format from Google Ads
              gtag('config', 'AW-16837922212/XTk1CM_48JUbEKSb-dw-', {
                'phone_conversion_number': '(928) 361-0298'
              });

              console.log('[DNI] Call tracking configured');
            }

            initCallTracking();

            // Track all phone link clicks as conversions
            document.addEventListener('click', function(e) {
              var link = e.target.closest('a[href^="tel:"]');
              if (link && typeof gtag !== 'undefined') {
                // Fire phone click event for GA4
                gtag('event', 'phone_click', {
                  'event_category': 'engagement',
                  'event_label': link.href,
                  'phone_number': link.href.replace('tel:', '')
                });

                // Fire Google Ads phone call conversion
                gtag('event', 'conversion', {
                  'send_to': 'AW-16837922212/XTk1CM_48JUbEKSb-dw-',
                  'value': 10.0,
                  'currency': 'USD'
                });

                console.log('[Phone Tracking] Click tracked:', link.href);
              }
            });
          })();
        `,
      }}
    />
  )
}